import { createMuiTheme } from '@material-ui/core';

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    sidebarWidth: number;
    sidebarMobileHeight: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
  }

  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    sidebarWidth?: number;
    sidebarMobileHeight?: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
  }
}

const defaultTheme = createMuiTheme();

export default createMuiTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        'html, body, #root': {
          height: '100%',
        },
      },
    },
    MuiButton: {
      root: {
        minHeight: '40px',
        borderRadius: '20px',
        padding: '5px 0 10px',
        textTransform: 'none',
        color: 'rgb(40, 42, 43)',
        fontSize: '1.2rem',
        lineHeight: '1.3rem',
        fontFamily: 'fieldwork, Helvetica, sans-serif',
        fontWeight: 600,
        transition: 'none',
        /*
        transition: defaultTheme.transitions.create(['background-color', 'box-shadow', 'border', 'color'], {
          duration: defaultTheme.transitions.duration.short,
        }),
        */
      },
      text: {
        background: 'none',
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
      outlinedPrimary: {
        border: '2px solid #8F09F9',
        '&:hover': {
          border: '2px solid rgb(1, 85, 137)',
        },
      },
      outlinedSecondary: {
        border: '2px solid #666666',
        color: '#ffffff',
        '&:hover': {
          border: '2px solid rgb(200, 200, 200)',
        },
      },
      startIcon: {
        marginRight: '6px',
      },
    },
    MuiTypography: {
      h1: {
        fontFamily: 'fieldwork, Helvetica, sans-serif',
        fontWeight: 'bold',
        fontSize: '2rem',
      },
      h2: {
        fontFamily: 'fieldwork, Helvetica, sans-serif',
        fontWeight: 'bold',
        fontSize: '1.9rem',
      },
      h3: {
        fontFamily: 'fieldwork, Helvetica, sans-serif',
        fontWeight: 'bold',
      },
      h4: {
        fontFamily: 'fieldwork, Helvetica, sans-serif',
        fontWeight: 'bold',
      },
      h5: {
        fontFamily: 'fieldwork, Helvetica, sans-serif',
        fontWeight: 'bold',
      },
      body1: {
        color: 'rgb(40, 42, 43)',
        fontSize: '1.1rem',
        lineHeight: '1.4rem',
      },
    },
    MuiInputBase: {
      root: {
        fontSize: '0.9rem',
      },
    },
    MuiSelect: {
      root: {
        padding: '0.85em',
      },
    },
    MuiDialogActions: {
      root: {
        padding: '16px',
      },
    },
    MuiTextField: {
      root: {
        color: 'rgb(40, 42, 43)',
      },
    },
    MuiInputLabel: {
      root: {
        color: 'rgb(40, 42, 43)',
        fontSize: '1.1rem',
        marginBottom: '0.2em',
        fontWeight: 500,
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: 'rgb(136, 140, 142)',
      },
    },
  },
  typography: {
    fontFamily: 'transat-text, Helvetica, sans-serif',
  },
  palette: {
    primary: {
      main: '#8F09F9',
    },
  },
  brand: '#E22525',
  footerHeight: 72,
  mobileFooterHeight: 56,
  sidebarWidth: 355,
  sidebarMobileHeight: 90,
  sidebarMobilePadding: 8,
  participantBorderWidth: 2,
  mobileTopBarHeight: 52,
});
